import { Component, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LanguageManagementService } from '../../../service/language-management.service';
import { CommunicationTemplate, InteractionType, KeyValueSet, LocalService, PageKey, PlanPurchaseInvoiceStatus, Status, TriggeredEvent, Wrappers15 } from '../../../service/local.service';
import { PlanPurchaseService } from 'src/service/plan-purchase.service';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { HtmlViewerComponent } from 'src/app/popups/html-viewer/html-viewer.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MessageComponent } from 'src/app/popups/message/message.component';

@Component({
  selector: 'app-invoices',
  templateUrl: './invoices.component.html',
  styleUrl: './invoices.component.scss'
})
export class InvoicesComponent {
  InteractionType = InteractionType;
  lstSectionConfigKeys: string[] = ["plan_purchase"]; PlanPurchaseInvoiceStatus = PlanPurchaseInvoiceStatus; CommunicationTemplate = CommunicationTemplate;
  userId: string = ''; ctryCode: string = ''; interactionType = InteractionType.None;
  wrapper: Wrappers15; maxBodyHeight = 0;

  IsPrint: boolean = false; printContent: string = ''; fileName: string = '';
  isOpenSendToPhone: boolean = false; selectedId: string = ''; isIncludeZero: boolean = false;

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private router: Router, private route: ActivatedRoute, private planPurchaseService: PlanPurchaseService, private languageManagementService: LanguageManagementService, private configurationManagementService: ConfigurationManagementService, private modalService: NgbModal) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.route.params.subscribe(routeParams => {
      this.interactionType = routeParams.interactionType;
      this.ctryCode = routeParams.ctryCode;
      this.userId = routeParams.userId;
      this.configurationManagementService.ensurePageActions(PageKey.Invoices);
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.onInitiate();
    });
  }

  onChangeAsCountry() {
    if (this.localService && this.localService.selected && this.localService.selected.countryCode) {
      const ctryCode = this.localService.selected.countryCode == this.localService.asCtryCode ? this.localService.asCtryCode : (this.localService.selected.countryCode + '-' + this.localService.asCtryCode);

      this.router.navigate([['/invoices', ctryCode, this.localService.selected.user, InteractionType.Auditor].join('/')]);
    }
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight();
    this.cdr.detectChanges();
  }

  onInitiate() {
    this.onLoad();
  }

  onLoad() {
    this.onGetInvoices();
  }

  onGetInvoices() {
    this.planPurchaseService.getInvoices(this.isIncludeZero, this.wrapper ? this.wrapper.paging : null).subscribe(result => {
      result.items.forEach(item => {
        item.v9 = this.onGetName(1, item.v3).value;
        item.v10 = this.onGetName(2, item.v6).value;
      });
      this.wrapper = result;
    });
  }

  onGetName(index: number, key: string): KeyValueSet {
    let item: KeyValueSet;
    switch (index) {
      case 1: {
        item = this.localService.deductionMethods.find(x => x.key == key);
      } break;
      case 2: {
        item = this.localService.planPurchaseInvoiceStatuses.find(x => x.key == key);
      } break;
    }
    return item ?? { value: 'Refresh' } as KeyValueSet;
  }


  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        this.onDownload();
      } break;
      case 2: {
        this.onUpload(key);
      } break;
      case 4: {
        this.onOpenInvoice(1, key);
      } break;
      case 5: {
        this.onOpenInvoice(2, key);
      } break;
      case 7: {
        this.selectedId = key;
        this.isOpenSendToPhone = true;
      } break;
      case 8: {
        const modalRef = this.modalService.open(MessageComponent);
        modalRef.componentInstance.IsConfirmationType = true;
        modalRef.componentInstance.message = this.localService.languageContent.common.delete_confirmation_general;
        modalRef.result.then((result) => {
          if (result.event == TriggeredEvent.Ok) {
            this.onRemoveToGst(key);
          }
        });
      } break;
      case 9: {
        this.onRefreshToGst();
      } break;
    }
  }

  onOpenInvoice(index: number, invoiceId: string) {
    this.planPurchaseService.getInvoice(invoiceId, index == 2).subscribe(result => {
      switch (index) {
        case 1: {
          const modalRef = this.modalService.open(HtmlViewerComponent, { size: 'xl' });
          modalRef.componentInstance.content = result.value;
          modalRef.componentInstance.isPopUp = true;
        } break;
        case 2: {
          this.fileName = result.key;
          this.IsPrint = true;
          this.printContent = result.value;
        } break;
      }
    });
  }

  onPrinted() {
    this.IsPrint = false;
  }

  onDownload() {
    this.planPurchaseService.getExcelData(this.isIncludeZero, this.wrapper ? this.wrapper.paging : null).subscribe(result => {
      this.localService.onDownloadFile(result, 'InvoicesReport_' + this.localService.getDeviceDateWithFormat('DD-MMM-YYYY'));
    });
  }

  onUpload(key: string) {
    this.planPurchaseService.uploadInvoiceToDrive(key).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
    });
  }

  onRefreshToGst() {
    this.planPurchaseService.refreshToGst(this.isIncludeZero, this.wrapper ? this.wrapper.paging : null).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        this.onLoad();
      }
    });
  }

  onRemoveToGst(key: string) {
    this.planPurchaseService.removeToGst(key).subscribe(result => {
      this.localService.showInformationByStatus(result.status);
      if (result.status == Status.Success) {
        this.onLoad();
      }
    });
  }
}
